import utils from '@os-plugins/util.js';

/**
 * 提交订单的所有数据
 * 无任何相应方法 单向同步
 * Just update adn clear(reset).
 */



export const state = () => ({
	longitude:"",// 经度  必传
	latitude:"",// 纬度       必传
	storeId:0,//门店id  必须传
	name:"", //姓名  type=1、2、4必传
	phone:"", //电话  type=1、2、4必传
	address:"", //地址（送餐地址或取餐地址）  type=1、2、4必传
	appendAddress:"",   //补全收货地址    xx楼之类的 (香港17-5月份需求)
	type:0, //点餐方式(1:外卖，2：自取 3:堂食  4：外卖预约）
	selfGetTime:"", //外卖预约+自取 预约时间/自取时间 格式：yyyy-MM-dd HH:mm:ss  type=2或者4的时候必须传
	sendTime:"",    //外卖单 白名单预送达时间  格式：yyyy-MM-dd HH:mm:ss
	paytype:0, //支付方式（1:餐到付款,2:在线支付） 必须传
	offlinePayType:0, //线下支付类型 参见枚举类offlinePayType
	isInvoice:false, //是否开发票  
	invoiceType:0, //发票类型 1:定额发票，2：机打发票 3:电子发票
	taxNo:"",  //税收序号 
	invoiceDesc:"", //发票抬头
	userNote:"", //用户备注
	couponId:0,  //优惠券id
	couponPid:0,// 优惠券餐品id,买一送一券时选择的餐品id
	menuId:0, //菜单id  必须传
	tableNum:"",    // 桌号   type=3必填
	peopleNum:0,  //就餐人数  type=3必填
	randomCode:"",      //提交订单随机码 格式：yyyyMMddHHmmssSS 必填
	cardCode:"",    //优惠卡号
	surcharge:0,    //附加费
	couponNo:"",    //优惠券唯一编码
	isJudgeOwnCoupon:false,//设置优惠券信息时,是否要判断用户是否拥有该券,false:不判断,true:判断,默认需要判断
	shareOrderId:0,   //分裂营销分享订单ID 20180302加入
	thirdUserId:"", //第三方用户id  口碑使用
	upgradeProduct:{}, //餐品升级信息
	manualPreferentials:[], //手动打折信息
	preferentials:[],    //优惠信息
	extraProductMap:[],//加价购餐品集合
	products:[], //餐品集合
});

var _state = utils.clearObject(state());

export const mutations = {
  update(state,data){
		for(var key in data){
			if(typeof state[key]!=='undefined'){
				state[key] = data[key];
			}
		}
	},
  clear(state){
		var temp = utils.clearObject(_state);
    for(var key in temp){
      state[key] = temp[key];
    }
	},
}

export const actions = {
  update({commit,state},data){
		commit('update',data);
	},

	
  clear({commit}){
		commit('clear');
	},

}



// WEBPACK FOOTER //
// ./../../store/booking/order.js